import { useSearchParams } from "react-router-dom";
import { SEARCH_PARAMS } from "../../utils/SearchParams";

export const useCustomSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const get = (key, defaultValue = undefined) =>
    searchParams.get(key) ?? defaultValue;

  const set = (key, value) => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);

      if (value === null || value === undefined || value === "") {
        params.delete(key);
      } else {
        params.set(key, String(value));
      }
      return params;
    });
  };

  const setMultiple = (paramsObj) => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);

      Object.entries(paramsObj).forEach(([key, value]) => {
        if (value === null || value === undefined || value === "") {
          params.delete(key);
        } else {
          params.set(key, String(value));
        }
      });

      return params;
    });
  };

  return { get, set, setMultiple };
};
